import { render, staticRenderFns } from "./WebCamBox.vue?vue&type=template&id=a5cc7aa6&scoped=true&"
import script from "./WebCamBox.vue?vue&type=script&lang=js&"
export * from "./WebCamBox.vue?vue&type=script&lang=js&"
import style0 from "./WebCamBox.vue?vue&type=style&index=0&id=a5cc7aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cc7aa6",
  null
  
)

export default component.exports